import { useEffect, useRef } from "react";
import { Section } from "./ui/section";

export const ContactUs = () => {
  const formContainerRef = useRef<HTMLDivElement>(null);
  const scriptLoadedRef = useRef(false);

  useEffect(() => {
    // Only load the script once
    if (scriptLoadedRef.current) return;

    const script = document.createElement("script");
    script.src = "https://js-eu1.hsforms.net/forms/embed/146924342.js";
    script.defer = true;
    script.onload = () => {
      scriptLoadedRef.current = true;
    };
    
    document.body.appendChild(script);

    return () => {
      // Cleanup: remove script when component unmounts
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <Section id="contact" className="bg-muted/30">
      <div className="max-w-3xl mx-auto text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">Get in Touch</h2>
        <p className="text-lg text-muted-foreground">
          Have questions or want to see Casey in action? Fill out the form below and we'll get back to you shortly.
        </p>
      </div>
      
      <div className="max-w-2xl mx-auto">
        <div 
          ref={formContainerRef}
          className="hs-form-frame bg-background rounded-lg p-8 shadow-sm" 
          data-region="eu1" 
          data-form-id="f117aab7-6522-428f-9428-d6ef0617c98a" 
          data-portal-id="146924342"
        />
      </div>
    </Section>
  );
};
